module.exports = __webpack_public_path__ + "img/_005.6633ae4c.png";